import { memo } from "react";
import Image from "../../../../../../Elements/Image/Image";

import styles from "./styles.module.scss";

const Background = memo(() => {
  return (
    <div className={styles.wrapper}>
      <div />
      <div className={styles.clouds}>
        <Image
          name="purchases/purchase-complete-cloud-left"
          ext="png"
          title=""
        />
        <Image
          name="purchases/purchase-complete-cloud-right"
          ext="png"
          title=""
        />
      </div>
      <div className={styles.whiteLine} />
    </div>
  );
});

export default Background;
